import {
	Component,
	EventEmitter,
	Input,
	OnDestroy,
	Output
} from "@angular/core";
import {ToasterNotificationTypeEnum} from "../enums";
import {NgSwitch, NgSwitchCase} from "@angular/common";
import {toasterNotificationConfig} from "../configs";

@Component({
	standalone: true,
	selector: "er-toaster-notification",
	templateUrl: "toaster-notification.component.html",
	styleUrls: ["toaster-notification.component.scss"],
	imports: [
		NgSwitch,
		NgSwitchCase
	]
})
export class ToasterNotificationComponent implements OnDestroy {

	@Input({required: true})
	public notificationType!: ToasterNotificationTypeEnum;
	@Input({required: true})
	public notificationTitle!: string;
	@Input({required: true})
	public notificationMessage!: string;
	@Output()
	public closeNotification: EventEmitter<void> = new EventEmitter<void>();
	@Output()
	public autoCloseNotification: EventEmitter<void> = new EventEmitter<void>();

	protected readonly ToasterNotificationType: typeof ToasterNotificationTypeEnum = ToasterNotificationTypeEnum;
	private readonly MAX_PERCENT: number = 100;

	public timerProgress: number | null = 0;
	public timerTransition: string | null = null;
	private timer: any;

	constructor() {
		this.startTimer();
	}

	public ngOnDestroy(): void {
		this.clearInterval()
	}

	public onCloseNotificationClick(): void {
		this.closeNotification.emit();
	}

	private startTimer(): void {
		const timerStep: number = toasterNotificationConfig.displayTimeInSeconds / 100;
		const timerStepTimeout: number = timerStep * 1000;

		this.timerTransition = "width " + timerStepTimeout + "ms ease-in-out";

		let currentPercent = 0;
		this.timer = setInterval((): void => {
			if (currentPercent != this.MAX_PERCENT) {
				currentPercent++;
				this.timerProgress = currentPercent;
			} else {
				this.autoCloseNotification.emit();
				this.clearInterval();
			}
		}, timerStepTimeout)
	}

	private clearInterval(): void {
		clearInterval(this.timer);
	}
}